import { registerQuery } from 'data-fetching-client';
import { fetchAssetsByIds } from 'personalization-lib/api/clients/assetApiClient';
const getAssetMap = assets => Object.fromEntries(assets.map(asset => [asset.id, asset]));
export const ASSETS_BY_IDS_QUERY = registerQuery({
  fieldName: 'assetsById',
  args: ['source', 'ids'],
  fetcher: args => fetchAssetsByIds(args).then(getAssetMap)
});